const SelectComponent = (
    { lableValue,
        selectName,
        selectId,
        options,
        onChange,
        defaultOptionSelected,
        optionHiddenText }) => {
    // console.log(defaultOptionSelected)
    return (
        <div className="d-flex flex-column">
            <label htmlFor="">{lableValue}</label>
            <select name={selectName} id={selectId} disabled={options === null} onChange={onChange}>
                <option value={null} hidden>{
                    options === null ?
                        "درحال بارگزاری.." :
                        optionHiddenText || "انتخاب فرمایید"
                }</option>
                {options !== null &&
                    options.map((option) => {
                        return <option key={option.value} value={option.value || option.id}
                            selected={defaultOptionSelected && defaultOptionSelected === option.value}
                        >{option.name}</option>
                    })
                }
            </select>
        </div>
    )
}
export default SelectComponent